var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "notice-dialog",
      attrs: {
        visible: _vm.dialogNoticeVisible,
        width: "55%",
        center: "",
        "append-to-body": true,
        "before-close": _vm.readNotice,
        "close-on-click-modal": false,
        "close-on-press-escape": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogNoticeVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "notice-content" },
        [
          _c("div", { staticClass: "header" }, [
            _c("div", { staticClass: "flex-row-start-center" }, [
              _c("div", { staticClass: "type-name" }, [
                _vm._v(_vm._s(_vm.detail.type_name))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "notice-title" }, [
                _vm._v(_vm._s(_vm.detail.title))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("Editor", {
            attrs: { value: _vm.detail.content },
            on: { onChange: _vm.onChange }
          }),
          _vm._v(" "),
          _vm.detail.notice_type === 1
            ? _c(
                "el-button",
                {
                  staticClass: "confirm-btn",
                  attrs: { type: "primary", loading: _vm.confirmLoading },
                  on: {
                    click: function($event) {
                      return _vm.readNotice(1)
                    }
                  }
                },
                [_vm._v("我知道了")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.detail.notice_type === 2
            ? _c(
                "div",
                { staticClass: "flex-row-between-center" },
                [
                  _c("el-alert", {
                    staticClass: "alert-warning",
                    attrs: {
                      title:
                        "注意！点击拒绝前请与负责的业务员沟通，知晓相关影响",
                      type: "warning",
                      "show-icon": "",
                      closable: false
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex-row-start-center" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "confirm-btn",
                          attrs: {
                            type: "primary",
                            loading: _vm.confirmLoading
                          },
                          on: {
                            click: function($event) {
                              return _vm.readNotice(1)
                            }
                          }
                        },
                        [_vm._v("同意")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "reject-btn",
                          on: { click: _vm.rejectNotice }
                        },
                        [_vm._v("拒绝")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e171d736", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e171d736","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notice/indexNew.vue
// module id = null
// module chunks = 